import React from 'react';
import PageHeader from '../common/pageHeader';

import './chat.scss';

const Chat = () => {
  return (
    <React.Fragment>
      <div className="container-fluid chat">
        <PageHeader titleText="Kdog Chat" className="text-center page-header" />
      </div>
      <div className="row m-auto">
        <div className="col-12 mt-2">
          <h4 className="text-center">
            Page Under Construction! Come back later!
          </h4>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Chat;
